import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import RotateRightIcon from '@material-ui/icons/RotateRight'
import RBarButton from './RBarButton'
import {
  modeSelector,
  MODE,
  rotateRight
} from '../../../modules/reducerRotator'

const useStyles = makeStyles((theme) => ({
  root: {}
}))

const RRotateRightButton = (props) => {
  const classes = useStyles()

  const mode = useSelector(modeSelector)
  const dispatch = useDispatch()

  const handleClick = useCallback(() => {
    dispatch(rotateRight(1))
  }, [dispatch])

  return (
    <RBarButton
      {...props}
      tooltip="Rotate right"
      onClick={handleClick}
      disabled={mode !== MODE.BUTTONS}
    >
      <RotateRightIcon fontSize="inherit" />
    </RBarButton>
  )
}
export default RRotateRightButton
